import React from "react";
import ProductDetail from ".";
import { MODEL_KEY } from "config/products";

function Iphone18Promax() {
  return <ProductDetail modelId={MODEL_KEY.IPHONE18PROMAX} />;
}

export default Iphone18Promax;
